import React from 'react';

export default function ContactHero({ title, description, image }) {
  return (
    <section className="relative min-h-[320px] md:h-[40vh] flex items-center justify-center overflow-hidden py-16 md:py-0">
      <img
        src={image}
        alt="Luxury Event Detail"
        className="absolute inset-0 w-full h-full object-cover object-center z-0 transition hover:brightness-110"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#1a2233]/90 via-[#23283a]/60 to-transparent"></div>
      <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-playfair text-white mb-4 drop-shadow-[0_4px_24px_rgba(24,28,36,0.9)]">
          {title}
        </h1>
        <p className="text-lg md:text-xl text-white font-light drop-shadow-[0_2px_12px_rgba(24,28,36,0.8)] mb-2">
          {description}
        </p>
      </div>
    </section>
  );
} 